var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0837 48.125V45.2083C49.0837 42.4902 47.2246 40.2063 44.7087 39.5588M39.6045 22.299C41.7423 23.1644 43.2503 25.2602 43.2503 27.7083C43.2503 30.1564 41.7423 32.2523 39.6045 33.1176M41.792 48.125C41.792 45.407 41.792 44.048 41.348 42.976C40.7559 41.5467 39.6203 40.4111 38.191 39.819C37.119 39.375 35.76 39.375 33.042 39.375H28.667C25.949 39.375 24.59 39.375 23.518 39.819C22.0887 40.4111 20.9531 41.5467 20.361 42.976C19.917 44.048 19.917 45.407 19.917 48.125M36.6878 27.7083C36.6878 30.93 34.0762 33.5417 30.8545 33.5417C27.6328 33.5417 25.0212 30.93 25.0212 27.7083C25.0212 24.4867 27.6328 21.875 30.8545 21.875C34.0762 21.875 36.6878 24.4867 36.6878 27.7083Z",
    stroke: "#2C99E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5bb183c9f31b9a93d3304b7d589d697b.svg";
export { ForwardRef as ReactComponent };